<div class="sidebar-item" [class.sidebar-item--hidden]="!isVisible()">
  <a href="{{ route }}" (click)="onClick($event)" class="sidebar-item__link">
    <div
      class="sidebar-item__btn"
      [class.sidebar-item__btn--active]="
        isSelfSelected() || isAnyChildSelected()
      "
      [class.sidebar-item__btn--collapsed]="!isSidebarOpen"
    >
      <img
        [src]="iconUrl"
        alt=""
        [class]="!iconUrl ? 'sidebar-item__left-icon' : ''"
      />
      <span class="sidebar-item__label">{{ title }}</span>
      @if (beta) {
        <span
          class="sidebar-item__beta"
          [class.sidebar-item__beta--collapsed]="!isSidebarOpen"
          >BETA</span
        >
      }
      <span
        class="sidebar-item__right-icon"
        [class.rotated]="isExpanded"
        [class.sidebar-item__right-icon--collapsed]="!isSidebarOpen"
      >
        @if (isCollapsable) {
          <img src="public/icons/navigation/down-arrow-icon.svg" alt="expand" />
        }
      </span>
      @if (!isCollapsable && newBtn && isSidebarOpen) {
        <span
          class="sidebar-item__options-icon"
          [title]="btnTitle"
          (click)="goToCreate($event)"
        >
          <img src="public/icons/actions/add-icon.svg" alt="agregar" />
        </span>
      }
    </div>
  </a>

  <!--
    El submenú se mantiene montado mientras la barra está abierta y solo se
    pliega con una clase: desmontarlo con `@if (isExpanded)` cortaba la
    animación de despliegue en seco.

    Va FUERA del `<a>` del padre a propósito. Estando dentro, cada hijo era un
    `<a>` anidado en otro `<a>` —HTML inválido— y el navegador resolvía por su
    cuenta a qué enlace pertenecía el clic.
  -->
  @if (isSidebarOpen) {
    <ul
      class="sidebar-item__list"
      [class.sidebar-item__list--collapsed]="!isExpanded"
    >
      <div class="sidebar-item__list-container">
        <ng-content></ng-content>
      </div>
    </ul>
  }
</div>
